export const RECENT_ARTICLES_TITLE = "Recent Articles";
export const IN_PRESS_ARTICLES = "In Press Articles";
export const ARCHIVE_TITLE = "Archive";
export const ORCID_ICON =
  "/images/orcid.svg";
export const PROOF_FINAL_PUBLISHED = "Final Published";
export const TITLE_ALLOWED_TAGS = [
  "i",
  "b",
  "strong",
  "sup",
  "sub",
  "ins",
  "del",
];
export const NO_IN_PRESS_ARTICLES_FOUND = "There is no In Press Articles, yet!";
export const NO_LATEST_ARTICLES_FOUND =
  "No articles have been published in this issue.";
export const NO_ARTICLES_FOUND = "There is no articles, yet!";
export const DATA_PUBLISH_DOI_LINK = "https://doi.org";
export const MOST_CITED_ARTICLES = "Most Cited Articles";
export const MOST_VIEWED_ARTICLES = "Most Viewed Articles";
export const MOST_DOWNLOADED_ARTICLES = "Most Downloaded Articles";
